import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';

@Component({
  selector: 'app-internet-connection-modal',
  templateUrl: './internet-connection-modal.component.html',
  styleUrls: ['./internet-connection-modal.component.scss']
})
export class InternetConnectionModalComponent {

  @Output() resetConnectionModal = new EventEmitter();
  @Input() isConnectionModalShown:boolean;

  err_msg = '';
  constructor(public mls: MultiLangService, public masterService: MasterserviceService, public mls2: NewLanguageService) { }

  showModal(): void {
    this.isConnectionModalShown = true;
  }

  hideModal(): void {
    this.isConnectionModalShown = false;
    this.resetConnectionModal.emit(0);
  }

  onHidden(): void {
    this.isConnectionModalShown = false;
    this.resetConnectionModal.emit(0);
  }

}
